import { DOCUMENT } from '@angular/common';
import { ApplicationConfig } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics, ScreenTrackingService } from '@angular/fire/analytics';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { providePerformance, getPerformance } from '@angular/fire/performance';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withFetch } from '@angular/common/http';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { WINDOW, windowProvider } from './providers/window';
import { MessagingService } from './core/messaging.service';
import { NotifyService } from './core/notify.service';

// Initialize Firebase app once
const firebaseApp = initializeApp(environment.firebase);

// Base Firebase providers that are always needed
const baseFirebaseProviders = [
  provideFirebaseApp(() => firebaseApp),
  provideAuth(() => getAuth(firebaseApp)),
  provideFirestore(() => getFirestore(firebaseApp)),
  provideAnalytics(() => getAnalytics(firebaseApp)),
  providePerformance(() => getPerformance(firebaseApp)),
  provideStorage(() => getStorage(firebaseApp))
];

// Conditional providers based on environment
const getEnvironmentProviders = () => {
  if (typeof window !== 'undefined') {
    return [
      ...baseFirebaseProviders,
      provideMessaging(() => getMessaging(firebaseApp))
    ];
  }
  return baseFirebaseProviders;
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideIonicAngular({
      mode: 'ios',
      animated: true,
      rippleEffect: true,
      hardwareBackButton: false
    }),
    provideHttpClient(withFetch()),
    {
      provide: WINDOW,
      useFactory: (document: Document) => windowProvider(document),
      deps: [DOCUMENT],
    },
    ...getEnvironmentProviders(),
    ScreenTrackingService,
    MessagingService,
    NotifyService
  ]
};
